import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Button, Input } from 'reactstrap';

import Prompt from '../../components/Prompt';


import actions from './actions';

class ListaAcessos extends Component {
  constructor (props) {
    super(props);

    this.state = {
      todos: false,
      confirm: false
    };

    this.toggleState = this.toggleState.bind(this);
    this.handleCancellation = this.handleCancellation.bind(this);
  }

  componentDidMount () {
    this.props.actions.onLoadListaAcessos();
  }

  toggleState (name) {
    return () => {
      this.setState(state => ({
        [name]: !state[name]
      }));
    };
  }

  handleCancellation (email) {
    this.toggleState('confirm')();

    const { value, status } = this.state;
    this.updateStatus({value, status, email});
  }

  updateStatus (data) {
    this.props.actions.onChangeRoleAcesso(data).then(() => {
      this.props.actions.onLoadListaAcessos();
    });
  }

  onChangeSituacao (value, status) {
    return () => {
      if (value.confirm) {
        this.setState({
          value,
          status,
          confirm: true
        });
      } else {
        this.updateStatus({status, value});
      }
    };
  }

  render () {
    let { todos, confirm } = this.state;
    let { value } = this.props;

    return (<Fragment><br /><Table>
      <thead>
        <tr>
          <th className="align-top">Nome</th>
          <th className="align-top">Perfil</th>
          <th className="text-right"><div className="form-group">Situação<br /><Input type="checkbox" onClick={this.toggleState('todos')} /></div></th>
        </tr>
      </thead>
      <tbody>
        {value.result
          .filter(v => todos || -1 !== v.status)
          .map(v => (<tr key={v.id} className={v.status?'':"list-group-item-warning"}>
          <td>{v.nome}</td>
          <td>{v.role}</td>
          <td className="text-right">
            {1 === v.status && <Button onClick={this.onChangeSituacao(v, -1)} color="danger" title="Desativar"><span className="fa fa-times"></span> <span className="d-none d-sm-inline-block">Desativar</span></Button>}
            {1 !== v.status && <Button onClick={this.onChangeSituacao(v, 1)} color="success" title="Ativar"><span className="fa fa-check"></span> <span className="d-none d-sm-inline-block">Ativar</span></Button>}
          </td>
        </tr>))}
      </tbody>
    </Table>
    <Prompt
      headerText="Confirma desativação?"
      isOpen={confirm}
      valid={value => -1 < value.indexOf("@")}
      toggle={this.toggleState('confirm')}
      onConfirm={this.handleCancellation}>
        Uma vez confirmado, você <b>NÃO</b> poderá fazer mais alterações nesta área.<br /><br />
        Se não é mais membro da administração, informe o e-mail do novo síndico:
    </Prompt>
    </Fragment>);
  }
}

let mapStateToProps = ({ admin: { acessos } }) => ({
  value: acessos
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaAcessos);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaAcessos.js